var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E1306C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 10.7981C13.1776 10.7981 10.8389 13.0965 10.8389 15.9594C10.8389 18.8223 13.1373 21.1207 16.0002 21.1207C18.8631 21.1207 21.1614 18.782 21.1614 15.9594C21.1614 13.1368 18.8227 10.7981 16.0002 10.7981ZM16.0002 19.2658C14.1856 19.2658 12.6937 17.7739 12.6937 15.9594C12.6937 14.1449 14.1856 12.6529 16.0002 12.6529C17.8147 12.6529 19.3066 14.1449 19.3066 15.9594C19.3066 17.7739 17.8147 19.2658 16.0002 19.2658Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3627 11.8465C22.0085 11.8465 22.5321 11.323 22.5321 10.6772C22.5321 10.0314 22.0085 9.50781 21.3627 9.50781C20.7169 9.50781 20.1934 10.0314 20.1934 10.6772C20.1934 11.323 20.7169 11.8465 21.3627 11.8465Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3871 7.65298C23.3387 6.56427 21.8468 5.99976 20.1532 5.99976H11.8468C8.33871 5.99976 6 8.33846 6 11.8465V20.1127C6 21.8465 6.56452 23.3385 7.69355 24.4272C8.78226 25.4756 10.2339 25.9998 11.8871 25.9998H20.1129C21.8468 25.9998 23.2984 25.4352 24.3468 24.4272C25.4355 23.3788 26 21.8869 26 20.153V11.8465C26 10.153 25.4355 8.70137 24.3871 7.65298ZM24.2258 20.153C24.2258 21.403 23.7823 22.411 23.0565 23.0965C22.3306 23.782 21.3226 24.1449 20.1129 24.1449H11.8871C10.6774 24.1449 9.66935 23.782 8.94355 23.0965C8.21774 22.3707 7.85484 21.3627 7.85484 20.1127V11.8465C7.85484 10.6369 8.21774 9.62879 8.94355 8.90298C9.62903 8.2175 10.6774 7.85459 11.8871 7.85459H20.1935C21.4032 7.85459 22.4113 8.2175 23.1371 8.9433C23.8226 9.66911 24.2258 10.6772 24.2258 11.8465V20.153Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter6);
export default __webpack_public_path__ + "static/media/footer6.470c5b42000a5022f5476371fd6cb222.svg";
export { ForwardRef as ReactComponent };